import { createBrowserRouter } from 'react-router-dom';
import { AuthGuard } from '@/components/layout/AuthGuard';
import { AppShell } from '@/components/layout/AppShell';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { DebtsPage } from '@/pages/DebtsPage';
import { DebtDetailPage } from '@/pages/DebtDetailPage';
import { DebtFormPage } from '@/pages/DebtFormPage';
import { IncomesPage } from '@/pages/IncomesPage';
import { ExpensesPage } from '@/pages/ExpensesPage';
import { CategoriesPage } from '@/pages/CategoriesPage';
import { SimulatorPage } from '@/pages/SimulatorPage';

// El catch-all de Express (ver backend/src/app.ts) hace que el refresh de
// cualquiera de estas URLs sirva el mismo index.html, así que
// createBrowserRouter (sin hash) funciona en producción.
export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <AuthGuard />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: '/', element: <DashboardPage /> },
          { path: '/deudas', element: <DebtsPage /> },
          { path: '/deudas/nueva', element: <DebtFormPage /> },
          { path: '/deudas/:id', element: <DebtDetailPage /> },
          { path: '/deudas/:id/editar', element: <DebtFormPage /> },
          { path: '/ingresos', element: <IncomesPage /> },
          { path: '/gastos', element: <ExpensesPage /> },
          { path: '/simulador', element: <SimulatorPage /> },
          { path: '/categorias', element: <CategoriesPage /> },
        ],
      },
    ],
  },
]);
